module.exports = __webpack_public_path__ + "static/r9-9ce0adb5b597f14b772000f4f2ed86a0.jpg";